import {
  createPastEventsQuery,
  createUpcomingEventsQuery,
} from "@api/solid-query/event";
import { LoadingSpinner } from "@components/LoadingSpinner";
import { Show, createEffect } from "solid-js";
import { EventList } from "./EventList";

export const EventArea = (props: {
  type: "upcoming" | "results";
  shouldBePrivate: boolean;
}) => {
  const eventQuery =
    props.type === "upcoming"
      ? createUpcomingEventsQuery()
      : createPastEventsQuery();

  createEffect(() => {
    console.log("events", eventQuery.data?.pages ?? "NO DATA");
  });

  const loading = () => eventQuery.isLoading;
  const events = () => {
    if (!eventQuery.data) return [];
    return eventQuery.data.pages.flatMap((p) => p.events);
  };

  return (
    <div class="w-full flex flex-col mt-4">
      <div class="w-full flex flex-col md:flex-row px-12">
        <Show when={!loading()} fallback={<LoadingSpinner />}>
          <div class="flex flex-col mt-0 md:mt-0 w-full">
            <div class="flex gap-2 mt-0 flex-col md:flex-row md:w-full md:justify-between md:items-center">
              <h2 class="text-primary font-bold text-3xl">
                {`${props.type === "results" ? "Past " : ""}${
                  props.shouldBePrivate
                    ? "Private"
                    : props.type === "results"
                    ? "Public"
                    : "Current"
                } Events`}
              </h2>
            </div>
            <div class="flex gap-2 mt-2 flex-col md:flex-column md:w-full md:justify-between">
              <Show when={props.type == "upcoming"}>
                <h3 class="text-primary font-bold text-xl">
                  {props.shouldBePrivate
                    ? "Your Event. Your Way. The Ultimate Team Challenge."
                    : "The Ultimate Riddler Experience. Compete Live. Win Big."}
                </h3>
                <p class="w-full text-md text-text-black mb-4">
                  {props.shouldBePrivate
                    ? `Take Riddler Road Rally private with a fully customized event designed for your needs. 
                  Our rallies are great for corporate team-building challenges, parties, exciting club competitions, 
                  and fundraisers. We’ll create a unique experience with app-based clues, GPS-tracked locations, and interactive challenges to keep the excitement going.`
                    : `Experience Riddler Road Rally in its purest form—a live,
                citywide competition where teams race against each other to
                solve clues on our app, navigate GPS-tracked locations, and
                compete for a growing cash jackpot. With pre-rally parties,
                surprise diversions, and real-time competition, this is where
                the thrill of the adventure begins.`}
                </p>
              </Show>
            </div>
            <Show
              when={events().length > 0}
              fallback={
                <div class="text-xl mt-4">
                  None yet. Check back soon for some amazing events!
                </div>
              }
            >
              <EventList
                events={events().filter(
                  (event) => event.private === props.shouldBePrivate
                )}
              />
            </Show>
            <Show when={eventQuery.hasNextPage}>
              <button
                class="btn btn-ghost mt-4"
                onClick={() => eventQuery.fetchNextPage()}
                disabled={eventQuery.isFetchingNextPage || eventQuery.isLoading}
              >
                Show More
              </button>
            </Show>
          </div>
        </Show>
      </div>
      <div class="flex justify-center mt-12 mb-4">
        <div class="text-primary font-bold text-md">
          Want to plan a private event? Go{" "}
          <a
            href="https://connect.riddlerroadrally.com/private-events"
            class="text-md link italic"
          >
            here
          </a>
        </div>
      </div>
    </div>
  );
};

export default EventArea;
